/**
 *
 * @component 用户中心/数据看板/巡检质量统计卡片
 *
 **/

import { Empty } from 'antd';
import { useHistory } from 'react-router-dom';
import BaseCard from '@/components/UserCenter/BaseCard';
import ECharts from '&/components/BaseECharts/index';
import { Select } from '&/components/AntdEncapsulation';
import { getItemData } from '@/api/personCenter/dataBoard';
import { barOption } from './constants';

import './QualityStatistics.scss';
// const merge = require('lodash/merge');
function QualityStatistics(props) {
    const {
        defaultValue,
        baseParams = {},
        managerOpts,
        dayOpts,
        isAdmin = false,
        userId = null,
    } = props;

    const [params, setParams] = useState({
        div: 5,
        managerId: userId,
        days: 30,
    });
    const [data, setData] = useState([]);

    const xAxis = [],
        qualified = [],
        notQualified = [],
        partQualified = [];

    for (const item of data) {
        xAxis.push({
            value: item['_id'].stageName,
        });
        qualified.push(item.qualified);
        notQualified.push(item.notQualified);
        partQualified.push(item.partQualified);
    }

    const options = {
        ...barOption,
        color: ['#71E4B7', '#EFB353', '#5781EE'],
        xAxis: {
            data: xAxis,
            type: 'category',
            axisTick: { show: true, alignWithLabel: true, interval: 0 }, // 刻度
            splitLine: {
                show: false, // 网格线
            },
            axisLine: {
                // 轴线
                show: true,
                lineStyle: {
                    color: '#E3E7F2',
                },
            },
            axisLabel: {
                color: 'rgba(0, 0, 0, 0.5)',
                show: true,
                interval: 0,
                rotate: -45,
                width: 60,
                overflow: 'truncate', //breakAll
                height: 14,
                margin: 5,
                verticalAlign: 'top',
            },
        },
        series: [
            {
                name: '合格',
                type: 'bar',
                barGap: '25%',
                barWidth: 9,
                label: {
                    show: false,
                },
                // emphasis: {
                //     focus: 'series',
                // },
                data: qualified,
            },
            {
                name: '部分合格',
                type: 'bar',
                barGap: '25%',
                barWidth: 9,
                label: {
                    show: false,
                },
                // emphasis: {
                //     focus: 'series',
                // },
                data: partQualified,
            },
            {
                name: '不合格',
                type: 'bar',
                barWidth: 9,
                label: {
                    show: false,
                },
                // emphasis: {
                //     focus: 'series',
                // },
                data: notQualified,
            },
        ],
    };
    options.grid.bottom = 28;
    options.legend.bottom = 6;

    const canInit = !params.managerId && params.days === 30;

    useEffect(() => {
        canInit && setData(defaultValue || []);
    }, [defaultValue]);

    useEffect(() => {
        !canInit && reloadData();
    }, [baseParams.entId]);

    const first = useRef(true);
    useEffect(() => {
        !first.current && reloadData();
        first.current = false;
    }, [params]);

    const onChange = (val, key) => {
        setParams(prev => {
            const next = { ...prev };
            return {
                ...next,
                [key]: val,
            };
        });
    };

    function reloadData() {
        const PARAMS = { ...baseParams, ...params };
        if (!baseParams.entId) {
            delete PARAMS.entId; // 让axios 自带entId
        }
        getItemData(PARAMS).then(({ data }) => {
            setData(data.getExamineQuality);
        });
    }

    const filterEl = (
        <>
            {managerOpts && (
                <Select
                    onChange={e => onChange(e, 'managerId')}
                    className="manager-select"
                    showSearch
                    filterOption={(input, option) =>
                        (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    options={managerOpts}
                    value={params.managerId}></Select>
            )}
            <Select
                value={params.days}
                onChange={e => onChange(e, 'days')}
                options={dayOpts}></Select>
        </>
    );

    const HISTORY = useHistory();
    const targetList = () => {
        const urlParam = new URLSearchParams('');
        if (!isAdmin) {
            urlParam.append('manager', userId);
        } else if (params.managerId) {
            urlParam.append('manager', params.managerId);
        }
        urlParam.append('days', params.days);
        const path = isAdmin
            ? '/user-center/administrator/inspection-list?' +
              urlParam.toString()
            : '/user-center/manager/inspection-list?' + urlParam.toString();
        HISTORY.push(path);
    };

    return (
        <BaseCard
            className="quality-statistics"
            title="巡检质量统计"
            headerExtra={filterEl}>
            {!data.length ? (
                <Empty
                    image={
                        require('&/assets/img/userCenter/emptyydata-object.png')
                            .default
                    }
                    imageStyle={{
                        height: 160,
                    }}
                    description={
                        <div className="hint-message">暂无数据</div>
                    }></Empty>
            ) : (
                <div onClick={targetList}>
                    <ECharts height="19.75rem" option={options}></ECharts>
                </div>
            )}
        </BaseCard>
    );
}

export default QualityStatistics;
